module.exports = "/images/resend-invitation.7583963df82253412e38536c0a485a8c.svg";